import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Genera un PDF de liquidación mensual al propietario (ejemplo descargable).
export function generarLiquidacionPDF({ agencia, color, liquidacion, periodo }) {
  const doc = new jsPDF();
  const rgb = hexToRgb(color || "#0F172A");

  // Encabezado
  doc.setFillColor(rgb.r, rgb.g, rgb.b);
  doc.rect(0, 0, 210, 28, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(agencia || "Inmobiliaria", 14, 13);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Liquidación mensual al propietario", 14, 21);

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(11);
  doc.text(`Propietario: ${liquidacion.propietario}`, 14, 40);
  doc.text(`Propiedad: ${liquidacion.direccion}`, 14, 47);
  doc.text(`Inquilino: ${liquidacion.inquilino}`, 14, 54);
  doc.text(`Período: ${periodo}`, 14, 61);

  const fmt = (n) => "$ " + Math.round(n).toLocaleString("es-AR");

  const filas = [
    ["Alquiler cobrado", fmt(liquidacion.montoAlquiler)],
    ...liquidacion.gastos.map((g) => [g.concepto, fmt(g.monto)]),
  ];

  autoTable(doc, {
    startY: 70,
    head: [["Concepto", "Importe"]],
    body: filas,
    theme: "grid",
    headStyles: { fillColor: [rgb.r, rgb.g, rgb.b], textColor: 255 },
    columnStyles: { 1: { halign: "right" } },
    styles: { fontSize: 10, cellPadding: 3 },
  });

  const y = doc.lastAutoTable.finalY + 8;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Neto a transferir al propietario:", 14, y);
  doc.text(fmt(liquidacion.neto), 196, y, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text(
    "Documento de ejemplo generado por la demo. Los importes son ficticios.",
    14,
    285
  );

  doc.save(`liquidacion-${liquidacion.contratoId}.pdf`);
}

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}
